import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './fonts/font.css'
import scroll from 'vue-seamless-scroll'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/styles.scss'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


const app = createApp(App)

app.use(store)
  .use(router)
  .use(scroll)
  .use(ElementPlus)
app.mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}